import { AgGrid } from "@jsq/ds/core";

/**
 * Provides the configuration for the sidebar of the PayeesTable ag-grid
 * @returns The sidebar definition for the ag-grid
 */
export const sideBarDefs = (): AgGrid.SideBarDef => {
  const toolPanels: AgGrid.ToolPanelDef[] = [
    {
      id: "filters",
      labelDefault: "Filters",
      labelKey: "filters",
      iconKey: "filter",
      toolPanel: "agFiltersToolPanel",
    },
    {
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: {
        suppressRowGroups: true,
        suppressPivotMode: true,
        suppressValues: true,
      },
    },
  ];

  return {
    position: "right",
    toolPanels,
  };
};
